import { Info } from "lucide-react";
import { cadStr } from "@/lib/pricing";

export const fmtDate = (iso) => (iso && !Number.isNaN(Date.parse(iso))
  ? new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" }) : iso);

// Existing Starter/Pro subscriber: paid period keeps its price, next renewal uses the current price.
export function KeepPriceNotice({ gf, compact = false }) {
  if (!gf) return null;
  const up = gf.upgrade;
  const changes = gf.new_customers_price_cad !== gf.current_price_cad;
  const renewal = gf.next_renewal_at ? <>on <strong>{fmtDate(gf.next_renewal_at)}</strong></> : null;
  return (
    <div className="mt-4 rounded-xl border border-cyan-200 bg-cyan-50/60 p-4 text-sm text-cyan-950" data-testid="plan-keep-price-notice">
      {!compact && (
        <div className="font-semibold inline-flex items-center gap-2">
          <Info className="w-4 h-4" /> {changes ? "Your subscription price changes at renewal" : "Your subscription price stays the same"}
        </div>
      )}
      <ul className="mt-2 space-y-1 text-xs text-cyan-900">
        <li data-testid="plan-keep-price-price">
          {changes
            ? <>You pay {cadStr(gf.current_price_cad)}/{gf.period} for the {gf.period} you've already paid. From your next renewal{renewal && <> {renewal}</>}, {gf.plan_label} is <strong>{cadStr(gf.new_customers_price_cad)}/{gf.period}</strong>. Nothing is re-billed for the current period.</>
            : <>{gf.plan_label} stays at <strong>{cadStr(gf.current_price_cad)}/{gf.period}</strong>.</>}
        </li>
        <li data-testid="plan-keep-price-fee">
          Performance Fee on verified sales from {fmtDate(gf.fees_from)}: <strong>{gf.current_fee.fee_pct}% or {cadStr(gf.current_fee.fee_minimum_cad)}</strong>, whichever is higher
          {gf.previous_fee && <> (was {gf.previous_fee.fee_pct}% or {cadStr(gf.previous_fee.fee_minimum_cad)})</>}. Earlier sales keep the fee they were recorded with.
        </li>
        {gf.new_for_you?.length > 0 && (
          <li data-testid="plan-keep-price-new">New for you, at no extra cost: {gf.new_for_you.join("; ")}.</li>
        )}
        {up && (
          <li data-testid="plan-keep-price-upgrade">
            {up.plan_label} adds {up.adds.join(", ")} for {cadStr(up.price_cad)}/{up.period}.
          </li>
        )}
      </ul>
    </div>
  );
}
